import { GetterTree } from 'vuex'
import { RootState } from '../../types'
import { FilesState } from './types'

export const getters: GetterTree<FilesState, RootState> = {
  getFilesToProcessWithLastBooking (state): Array<{ uuid: string; file: File }> | null {
    return state.filesToProcessWithLastBooking
  }
}
